import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { PaymentSource, PaymentMethod } from '@/Payment/Enums';
import { PaymentSubmission } from '@/Payment/PaymentSubmission';
import VatsAPI from '@/Shared/VatsAPI';
import { PaymentResult } from '@/Payment/PaymentResult';
import { Dictionary } from 'vue-router/types/router';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import Customer from '@/Customer/Customer';
import { User } from '@/Stores/UserStore';

const paymentPropsMixin = mixins(LocationBasedMixin).extend({
    props: {
        controllerName: {
            required: true,
            type: String
        },
        recordsToPay: {
            required: true,
        },
        customer: {
            required: false,
            type: Object as () => Customer,
        },
        blocked: {
            required: true,
            type: Boolean
        },
        source: {
            required: true,
            type: String as () => keyof PaymentSource,
            default: PaymentSource.Online
        },
        method: {
            required: true,
            type: String as () => keyof PaymentMethod,
            default: PaymentMethod.Card
        },
        isInternal: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            validationErrors: {} as Dictionary<string[]>,
            paymentSource: this.source,
            paymentMethod: this.method,
        };
    },
    computed: {
        submission(): PaymentSubmission<any> {
            throw new Error(`Must override computed property 'submission()'`);
        },
        submissionUrl(): string {
            return `${this.location}/${this.controllerName}/${this.paymentMethod}/payment`;
        }
    },
    methods: {
        // Empty method to be optionally overridden
        // tslint:disable-next-line
        async afterSubmit(response: PaymentResult) {

        },
        async submit() {
            this.loading = true;
            this.$emit('paymentSubmitting');
            this.validationErrors = {};
            try {
                const response = await VatsAPI.post<PaymentResult>(this.submissionUrl, this.submission);
                const paymentResult = await response.data;
                await this.afterSubmit(paymentResult);

                if (!paymentResult.success) {
                    this.$emit('paymentFailed', paymentResult);
                    return;
                }

                this.$emit('paymentSucceeded', paymentResult);
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                this.$emit('paymentErrored', e);
            }
            finally {
                this.loading = false;
            }
        }
    }
});

export default paymentPropsMixin;
